module.exports = __webpack_public_path__ + "7d0646e756e1cf08ebed32af3e41af40.MP3";